import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestRatingDismissDelete = {
    path: "/rating/:slug/dismiss",
    method: RouteHttpVerb.DELETE
};
